import {defineStore} from "pinia";
import {computed, ComputedRef} from "vue";

export interface ShopConfig {
  shopId: number;
  hasOnlineReserveForm: boolean;
}

export const useShopConfigStore = defineStore('shopConfig', {
  state: (): { shopConfigs: ShopConfig[] } => ({
    shopConfigs: [],
  }),
  actions: {
    setShopConfigs(shopConfig: ShopConfig[]) {
      this.shopConfigs = shopConfig;
    },
    removeShopConfigs() {
      this.shopConfigs = [];
    },
  },
  getters: {
    getShopConfigs(state): ComputedRef<ShopConfig[]> {
      return computed(() => state.shopConfigs);
    },
  },
});
